export function movePosition(ids: string[], target: string, before: string) {
  const cleanIds = ids.filter((id) => id !== target);
  if (!before) {
    return cleanIds.concat(target);
  }
  const index = cleanIds.findIndex((id) => id === before);
  cleanIds.splice(index, 0, target);

  return cleanIds;
}
